import { Text, type TextStyle } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight } from '~/utils'

export const Description = styled(Text, theme => {
  const defaultFontWeight = String(
    theme.fontWeightRegular
  ) as TextStyle['fontWeight']

  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontFamily: theme.fontFamily.regular,
      fontSize: theme.fontSizeThreeandhalfpulse,
      fontWeight: defaultFontWeight,
      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),
    },
    variants: {},
  }
})
